import { AffiliateAdminPhotoType } from 'components/Admin/DirectoryPage/ImageModal'
import { createRequestInstance } from 'services'
import { AffiliateImages } from 'types'

export const AFFILIATES_URL = import.meta.env.VITE_AFFILIATES_URL || ''

const request = createRequestInstance({
  baseURL: AFFILIATES_URL,
})

export async function deleteAffiliatePhoto(
  id: number,
  fileName: string,
  type: AffiliateAdminPhotoType,
  userId?: number,
) {
  const { data } = await request.post(
    `${AFFILIATES_URL}/affiliates/${id}/images/delete()`,
    {
      file: fileName,
      type: type,
      ...(userId && { user_id: userId }),
    },
  )

  return data as unknown as AffiliateImages
}
